import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Container, Tab, Tabs } from 'react-bootstrap';
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

import { getAllNFTs, getMyAuctions, getMyAuctionDetails } from '../components/blockchain functions/BlockchainFunctions';
import { LoginContext } from "../context/LoginContext";
import GetNFT from '../components/page-components/getNFT';
import { validGameNFT } from "../components/page-components/Random";
//icons
import collection from '../components/assets/icons/archives-document.svg';


const MyCollection = () => {
  const history = useHistory();
  const [loginData, setLoginData] = useContext(LoginContext);
  const [nftCollectionData, setNFTCollectionData] = useState([]);
  const [nftInAuctionData, setNFTInAuctionData] = useState([]);

  useEffect(async () => {
    if (loginData == null) { return; }
    if (loginData.walletAddress != "") {
      //My NFTs
      let NFTCollections = await getAllNFTs(loginData.walletAddress, 30);
      setNFTCollectionData(NFTCollections);
      console.log(NFTCollections);

      //My NFTs In Auction
      let nftInAuctionList = await getMyAuctions(loginData.walletAddress);
      let nftInAuctiondataList = [];
      // console.log(auctionList);
      for (let i = 0; i < nftInAuctionList.length; i++) {
        let nftInAuction = nftInAuctionList[i];
        nftInAuctiondataList.push(await getMyAuctionDetails(nftInAuction));
      }
      setNFTInAuctionData(nftInAuctiondataList);
      console.log(nftInAuctiondataList);
    }
  }, [loginData?.walletAddress]);

  return (
    <>
      <div className="page-heading">
        <h2><img style={{height:"3rem"}} src={collection}/> My Collections</h2>
        <span>Here you view your NFT!</span>
      </div>
      <Tabs defaultActiveKey="All" id="uncontrolled-tab-example" className="mb-3">
        <Tab eventKey="All" title="All">

          <div>
            <Row>
              {nftCollectionData.map((data, key) => {
                return (
                  validGameNFT(data.name) ?
                    <Col sm={3} onClick={e => history.push('/view-nft/' + data.assetId)} key={key}>
                      <div className="nftData">
                        <GetNFT nftName={data.name} />
                        <div className="details">
                          <span className="name">{data.name}</span><span className="issueHeight">#{data.issueHeight}</span><br />
                          <span className="assetId"><span className="fw-bold">AssetId</span>: {data.assetId}</span><br />
                          <span className="timestamp">{(new Date(data.issueTimestamp)).toLocaleString()}</span>
                        </div>
                      </div>
                    </Col>
                    : <></>
                );
              })}
            </Row>
          </div>

        </Tab>
        <Tab eventKey="In auction" title="In auction" id="InAuction">

          <div>
            <Row>

              {nftInAuctionData.map((data, key) => {
                return (
                  validGameNFT(data.assetData.name) ?
                    <Col sm={3} onClick={e => history.push('/view-auction/' + data.auctionId)} key={key}>
                      <div className="nftData">
                        <GetNFT nftName={data.assetData.name} />
                        <div className="details">
                          <span className="name">{data.assetData.name}</span><span className="issueHeight">#{data.assetData.issueHeight}</span><br />
                          <span className="assetId"><span className="fw-bold">AssetId</span>: {data.assetData.assetId}</span><br />
                          <span className="assetId"><span className="fw-bold">No. of Bids</span>: {data.totalBids}</span><br />
                          <span className="timestamp">{(new Date(data.assetData.issueTimestamp)).toLocaleString()}</span>
                        </div>
                      </div>
                    </Col>
                    : <>
                    {/* NFT is invalid {data.auctionId} */}
                    </>
                );
              })}
            </Row>
          </div>

        </Tab>
        <Tab eventKey="Items" title="Items">

          <div>
            <Row>
              <p style={{textAlign:'center'}}>Coming soon...</p>
            </Row>
          </div>

        </Tab>
      </Tabs>
    </>
  )
}

export default MyCollection